import React, { PureComponent } from 'react';

class CreditoDebito extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ingresoAjuste, selectRadioIngresoAjustes, permisos } = this.props;
        const { motivoAjusteDataFiltrado, ajusteEdicion, motivoAjusteEdicion, debitoCredito} = this.props.ingresoAjuste;
        let rdButtonHabilitados, debitoCreditoSeleccionado;

        //motivoAjusteDataFiltrado: Objeto que se obtiene resultado del ajuste/cargo seleccionado
        //ingresoAjuste: Objeto del state que se carga con los datos que el usuario seleccione en pantalla
        //Si se seleccionó un motivo de ajuste se obtiene el Objeto y se consulta por el radio button que le corresponde
        //Si es 0 el usuario podrá seleccionar Debito/Credito, caso contrario se bloquea la seleccion y se carga el correspondiente
        //Si motivoAjusteDataFiltrado.DebitoCredito == 0 y  this.props.ingresoAjuste.debitoCredito != 0...
        //...siginifica que el usuario seleccionó un radio button y se le asignara el que se guarde en state.

        if (motivoAjusteDataFiltrado) {
            if(motivoAjusteDataFiltrado.DebitoCredito != 0){
                debitoCreditoSeleccionado = motivoAjusteDataFiltrado.DebitoCredito;
            }
            else if (motivoAjusteDataFiltrado.DebitoCredito == 0 && this.props.ingresoAjuste.debitoCredito == 0)//Revisar si esta bien esto
                debitoCreditoSeleccionado = 0;
            else
                debitoCreditoSeleccionado = this.props.ingresoAjuste.debitoCredito;
        } else {
            debitoCreditoSeleccionado = this.props.ingresoAjuste.debitoCredito;
        }

        //En caso que DebitoCredito sea 0 o null se devuelve FALSE para que seleccione debito o credito
        //TRUE = Radio Button Inhabilitados - FALSE = Radio Button Habilitados
        if (motivoAjusteDataFiltrado) {
            if (motivoAjusteDataFiltrado.DebitoCredito == null || motivoAjusteDataFiltrado.DebitoCredito == 0)
                rdButtonHabilitados = false;
            else
                rdButtonHabilitados = true;
        } else {
            rdButtonHabilitados = false;
        }

        //si no tiene permiso de alta se anula la seleccion de credito/debito
        rdButtonHabilitados = permisos && !permisos.Alta ? true : rdButtonHabilitados;

        if (ajusteEdicion) {
            debitoCreditoSeleccionado = ajusteEdicion.DebitoCredito ? 2 : 1;
            
            //ADT-2020 - Si el motivo del ajuste/concepto del cargo es debitoCredito = 0 (acepta ambos) y se selecciona desde una modificación
            // se elige el radiobutton que se seleccionó y no se toma por default el que está marcado en el movimiento
            debitoCreditoSeleccionado = debitoCredito && motivoAjusteEdicion && motivoAjusteEdicion[0].DebitoCredito == 0 ? debitoCredito : debitoCreditoSeleccionado;
        }

        let errorDebitoCredito = ingresoAjuste && ingresoAjuste.errorDebitoCredito ?
            <label style={{ marginLeft: "18px" }} className="error">Seleccione una opción</label>
            :
            null;

        //ADT-2020 - Se verifica que el motivoId recibido en motivoAjusteDataFiltrado se corresponda con el motivoId guardado en motivoAjusteEdicion
        // para los casos en que se modifique un movimiento, y así poder verificar si dicho motivo del ajuste/concepto del cargo tiene debitoCredito = 0, para
        // habilitar los radio buttons.

        if(motivoAjusteEdicion && motivoAjusteDataFiltrado) {
            rdButtonHabilitados = motivoAjusteDataFiltrado.MotivoId == motivoAjusteEdicion[0].IdMotivo && motivoAjusteEdicion[0].DebitoCredito == 0 && motivoAjusteDataFiltrado.Codigo == motivoAjusteEdicion[0].Codigo ? false : rdButtonHabilitados;
        }

        return (
            <div className="row top-separator-xs">

                <div className="col-xs-6">
                    <label className="label-primary">Débito/Crédito *</label>
                    <div className="row">
                        <div className="col-xs-3 padding-rd-button">

                            <div className="container-radio radio-margin" >
                                <div className="row">
                                    <div className="col-xs-12">
                                        <input id={"credito"} type="radio" disabled={rdButtonHabilitados} name="ma" value={2} onChange={(e) => selectRadioIngresoAjustes("debitoCredito", 2)} checked={debitoCreditoSeleccionado == 2} />
                                        <label className="lbl-radio label-secondary" htmlFor={"credito"}>Crédito</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className="container-radio radio-margin" >
                                <div className="row">
                                    <div className="col-xs-12">
                                        <input id={"debito"} type="radio" disabled={rdButtonHabilitados} name="ma" value={1} onChange={(e) => selectRadioIngresoAjustes("debitoCredito", 1)} checked={debitoCreditoSeleccionado == 1} />
                                        <label className="lbl-radio label-secondary" htmlFor={"debito"}>Débito</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {errorDebitoCredito}
                    </div>
                </div>
            </div>
        )
    }
}

export default CreditoDebito;